
import oNeighborhoodMap from '../organisms/neighborhood/NeighborhoodMap.vue';

export default {
    name: 't-municipality',
    components: {
        oNeighborhoodMap,
    },
};
